import Product from "./Product";
import { useState, useEffect } from "react";


const Products = () => {
  // const { name} = useContext(CartContext);
    const [products, setProducts] = useState([]);
    useEffect(() => {
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            const response = await fetch('/products.json');
            if (!response.ok) {
                throw new Error('Failed to fetch products');
            }
            const data = await response.json();
            setProducts(data);
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    return (
        <div className='container mx-auto pb-24'>
            <h1 className='text-lg font-bold my-8'>Products</h1>
            <div className='grid grid-cols-2 md:grid-cols-4 my-5 gap-20'>
                {
                    products.map(product => <Product key={product.id} product={product}/>)
                }
                
            </div>
        </div>
    )
}

export default Products
